var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7652 2.28314C15.266 0.755765 13.5664 -0.0169884 12.0874 0.610962C11.2653 0.959948 10.3249 0.886761 9.56676 0.41481C8.20263 -0.4344 6.40395 0.066118 5.67454 1.49789C5.26917 2.29361 4.50169 2.84206 3.61757 2.96784C2.02673 3.19415 0.97058 4.73374 1.33215 6.2994C1.53309 7.16952 1.29771 8.08299 0.701282 8.74764C-0.371904 9.94358 -0.191329 11.8019 1.09203 12.7688C1.80527 13.3062 2.21212 14.1572 2.18246 15.0498C2.12909 16.6558 3.46189 17.9632 5.06655 17.879C5.95834 17.8322 6.81706 18.2226 7.36804 18.9254C8.35946 20.19 10.2209 20.3348 11.396 19.2389C12.049 18.6298 12.9578 18.3769 13.8316 18.5611C15.4039 18.8925 16.923 17.807 17.1187 16.2121C17.2275 15.3257 17.7611 14.5479 18.5489 14.1273C19.9664 13.3705 20.4322 11.5626 19.557 10.215C19.0706 9.46607 18.9793 8.52718 19.3125 7.69863C19.9119 6.20775 19.1066 4.52331 17.57 4.05361C16.7159 3.79257 16.0426 3.13199 15.7652 2.28314Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9335 6.06372L8.11659 12.9678L4.96094 9.76706",
    stroke: "white",
    strokeWidth: 2.35324
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovals);
export default __webpack_public_path__ + "static/media/approvals.96f45ea93f048e58fa7e548e7b3e2a75.svg";
export { ForwardRef as ReactComponent };